import staticContentForDevelopment from "@/public/static-content/static-content (development).json";
import staticContentForProduction from "@/public/static-content/static-content (production).json";

export const globalStaticContent =
  process.env.NODE_ENV === "development" ? staticContentForDevelopment : staticContentForProduction;

export const primaryCourseContent = globalStaticContent.courses?.[0];
